import React, { useState } from 'react';
import Select from 'react-select';

const CouponModal = ({ isOpen, setIsOpen, statusOptions, handleSubmit, couponform, handleChange, setCouponForm }) => {

    console.log(couponform)
    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Coupon Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="coupon" className="oms-form-label">
                            Coupon
                        </label>
                        <input
                            type="text"
                            id="Coupon"
                            name='Coupon'
                            value={couponform.Coupon}
                            onChange={handleChange}
                            placeholder="Enter coupon code"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="percentage_offer" className="oms-form-label">
                            Discount (%)
                        </label>
                        <input
                            type="number"
                            id="percentage_offer"
                            name='percentage_offer'
                            value={couponform.percentage_offer}
                            onChange={handleChange}
                            placeholder="Enter discount percentage"
                            onWheel={(e) => e.target.blur()}
                            disabled={couponform.price_offer !== ""}
                            style={{ backgroundColor: couponform.price_offer !== "" ? '#f0f0f0' : 'white' }}
                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="price_offer" className="oms-form-label">
                            Price Discount
                        </label>

                        <input
                            type="number"
                            id="price_offer"
                            name="price_offer"
                            value={couponform.price_offer}
                            onChange={handleChange}
                            placeholder="Enter price discount"
                            onWheel={(e) => e.target.blur()}
                            disabled={couponform.percentage_offer !== ""}
                            style={{ backgroundColor: couponform.percentage_offer !== "" ? '#f0f0f0' : 'white' }}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="start" className="oms-form-label">
                            Start Date
                        </label>
                        <input
                            type="date"
                            id="start"
                            name='start'
                            value={couponform.start}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="end" className="oms-form-label">
                            End Date
                        </label>
                        <input
                            type="date"
                            id="end"
                            name='end'
                            value={couponform.end}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="used_by" className="oms-form-label">
                            Coupon Usage
                        </label>
                        <input
                            type="number"
                            id="used_by"
                            name='used_by'
                            value={couponform.used_by}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                            placeholder="Enter coupon usage limit"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        {/* <Select
                            id="status"
                            options={statusOptions}
                            onChange={(selectedOption) =>
                                setCouponForm((prev) => ({ ...prev, status: selectedOption }))
                            }
                            placeholder="Select status"
                        /> */}
                        <Select
                            id="status"
                            options={statusOptions}
                            value={statusOptions.find(option => option.value === couponform.status?.value || couponform.status)}
                            onChange={(selectedOption) =>
                                setCouponForm((prev) => ({ ...prev, status: selectedOption }))
                            }
                            placeholder="Select status"
                        />

                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CouponModal;
